"use strict";
var Backbone = require('dibs-backbone');
var Attachment = require('bunsen/models/Attachment');
var Clump = require('bunsen/libraries/clump');
var endpoints = require('dibs-endpoints');
var bunsen = require('bunsen/libraries/bunsen');
var _ = require('underscore');
var result = require('lodash.result');
var $ = require('dibs-jquery-shim');

module.exports = Backbone.Collection.extend({
    model : Attachment,
    initialize : function (models, options) {
        var firstAttachmentAdded;
        var _attachmentAdded;
        options = $.extend({
            uploadType : 'message_center',
            directory : undefined,
            maxCombinedAttachmentSize : undefined,
            uploadOnAdd : true,
            saveOptions : undefined
        }, options);
        this._maxCombinedAttachmentSize = options.maxCombinedAttachmentSize;
        this._saveOptions = options.saveOptions;
        this.on({
            add : attachment => {
                this._uploadingAttachment = true;
                this.gotDirectory.done($.proxy(attachment, 'set', 'dir'));
                if (options.uploadOnAdd) {
                    this.gotDirectory.done(bunsen.gandalf($.proxy(attachment, 'save', null, this._saveOptions)));
                }
            },
            remove : function (attachment) {
                attachment.destroy({
                    success: () => result(attachment.lastSave, 'abort')
                });
            }
        });
        if (options.directory) {
            this.gotDirectory = $.Deferred().resolve(options.directory);
            return;
        }
        // make request for the upload directory after the first model has been added
        firstAttachmentAdded = $.Deferred();
        _attachmentAdded = function (addedAttachment) {
            if (!addedAttachment.isNew()) {
                return;
            }
            this.off('add', _attachmentAdded);
            firstAttachmentAdded.resolve();
        };
        this.on('add', _attachmentAdded, this);
        this.gotDirectory = firstAttachmentAdded.then($.proxy(this, '_fetchDirectory', options.uploadType));
    },
    comparator: function (modelA, modelB) {
        if (!this._uploadingAttachment) {
            return modelA.get('attachmentType').localeCompare(modelB.get('attachmentType'));
        }
    },
    hasRoomFor: function (bytes) {
        if (undefined === this._maxCombinedAttachmentSize) {
            return true;
        }
        return bytes < this._maxCombinedAttachmentSize - this.getTotalSize();
    },
    getTotalSize: function () {
        return _.reduce(this.pluck('fileSize'), function (memo, num) { return memo + num; }, 0);
    },
    sync : function () {
        var unsavedAttachments = _.filter(this.models, function (attachment) {
            return !attachment.lastSave || attachment.lastSave.state() === "rejected";
        });
        if (0 === this.length) {
            return $.Deferred().resolve();
        }
        return this.gotDirectory.then(directory => {
            _.invoke(unsavedAttachments, 'set', 'dir', directory);
            _.invoke(unsavedAttachments, 'save', null, this._saveOptions);
            return $.when.apply($, _.pluck(this.models, 'lastSave'));
        });
    },
    _fetchDirectory : function (uploadType) {
        var endpointUpload = uploadType === 'itemImage' ? endpoints.itemImageUpload : endpoints.cmsUpload;

        return Clump.ajax({
            type: 'POST',
            url: endpointUpload(uploadType) + "?" + $.param($.extend({
                cleanup : 'N',
                execute : 'N'
            }, bunsen.getToken()))
        }).then(function (data) {
            return data.result.fileUpload.dir;
        });
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/collections/AttachmentList.es.js